(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

		const getRevoqPopupTrigger = () => {
			const revoqSource = document.querySelector('[data-widerruf-popup-source]');
			return revoqSource?.shadowRoot?.querySelector('[data-widerruf-popup-open]')
				|| document.querySelector('[data-widerruf-popup-open]');
		};

		const openRevoqPopup = () => {
			if (window.RevoqWithdrawal?.open) {
				window.RevoqWithdrawal.open();
				return;
			}

			document.dispatchEvent(new CustomEvent('revoq:open'));

			const revoqTrigger = getRevoqPopupTrigger();
			if (revoqTrigger) {
				revoqTrigger.click();
			}
		};

		const hideRevoqSectionTrigger = () => {
			const revoqSource = document.querySelector('[data-widerruf-popup-source]');
			const triggerWrap = revoqSource?.shadowRoot?.querySelector('.widerruf-popup-trigger-wrap')
				|| document.querySelector('[data-widerruf-popup-source-kind="section"] > .widerruf-popup-trigger-wrap');

			if (triggerWrap) {
				triggerWrap.style.display = 'none';
			}
		};

		hideRevoqSectionTrigger();
		setTimeout(hideRevoqSectionTrigger, 500);
		setTimeout(hideRevoqSectionTrigger, 1500);

		document.querySelectorAll('[data-revoq-withdrawal-link]').forEach((link) => {
			if (link.dataset.revoqWithdrawalBound === 'true') return;

			link.dataset.revoqWithdrawalBound = 'true';
			link.addEventListener('click', (event) => {
				event.preventDefault();
				openRevoqPopup();
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();
